
  <img
    class="amplify-image"
    (click)="onImageClicked()"
    src="{{url}}"
  />
